import moment from 'moment'

const date = (value, format = 'DD/MM/YYYY') => {
  return value ? moment(value).format(format) : ''
}

export default date
